var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import classnames from 'classnames';
import memoizeOne from 'memoize-one';
import { Dropdown } from '../Dropdown';
const GroupedSelectItem = (props) => {
    const content = props.content !== undefined ? props.content : props.text;
    return (React.createElement(React.Fragment, null,
        props.index === 0 && props.group && (React.createElement("div", { className: "group" }, props.group)),
        React.createElement("span", { className: "text" }, content)));
};
export class Select extends Component {
    constructor(props) {
        super(props);
        this.memoizedOptions = memoizeOne((options, searchQuery, value, multiple) => {
            const splitedOptions = this.splitOptions(options, searchQuery, value, multiple);
            return [
                ...this.groupOptions(splitedOptions.available),
                ...splitedOptions.selected,
                ...splitedOptions.excluded,
            ];
        });
        this.handleChange = (event, data) => {
            /*
             * search query is cleared every time Select is closed,
             * so if this.props.multiple !== true search query will be an empty string anyway
             * because Select will be closed after an element is selected
             */
            if (this.searchQuery && this.props.multiple) {
                const splittedOptions = this.splitOptions(this.props.options, this.searchQuery, data.value, this.props.multiple);
                // Semantic UI resets filter (without event firing) when selected last filtered element
                if (splittedOptions.available.length === 0) {
                    const searchData = Object.assign(Object.assign({}, data), { searchQuery: '' });
                    this.handleSearchChange(event, searchData);
                }
            }
            data.value = data.value === '' ? undefined : data.value;
            if (this.props.onChange) {
                this.props.onChange(event, data);
            }
        };
        this.handleSearchChange = (event, data) => {
            if (this.props.grouped && !this.props.hasOwnProperty('searchQuery')) {
                this.setState({
                    searchQuery: data.searchQuery,
                });
            }
            if (this.props.onSearchChange) {
                this.props.onSearchChange(event, data);
            }
        };
        // Semantic UI resets filter (without event firing) on select close
        this.handleClose = (event, data) => {
            const searchData = Object.assign(Object.assign({}, data), { searchQuery: '' });
            this.handleSearchChange(event, searchData);
            if (this.props.onClose) {
                this.props.onClose(event, data);
            }
        };
        this.splitOptions = memoizeOne((options, searchQuery, value, multiple) => {
            const available = [];
            const selected = [];
            const excluded = [];
            for (const option of options) {
                if (multiple) {
                    if (Array.isArray(value) && value.includes(option.value)) {
                        selected.push(option);
                        continue;
                    }
                }
                if (!searchQuery ||
                    this.isOptionSuitable(option, searchQuery)) {
                    available.push(option);
                }
                else {
                    excluded.push(option);
                }
            }
            return {
                available,
                selected,
                excluded,
            };
        });
        this.groupOptions = (options) => {
            const groups = options.reduce((result, current) => {
                const group = current.group || '';
                if (!result[group]) {
                    result[group] = [];
                }
                result[group].push(current);
                return result;
            }, {});
            return [].concat(
            // building flat list of options
            ...Object.keys(groups)
                .sort()
                .map(
            // sorting groups and converting them to the collection
            (group) => groups[group].map((option, index) => (Object.assign(Object.assign({}, option), { index, className: classnames(option.className, index === 0 && 'with-group'), content: (React.createElement(GroupedSelectItem, Object.assign({ index: index }, option))) })))));
        };
        this.state = {
            searchQuery: '',
        };
    }
    get searchQuery() {
        return this.props.hasOwnProperty('searchQuery')
            ? this.props.searchQuery
            : this.props.grouped
                ? this.state.searchQuery
                : undefined;
    }
    get options() {
        if (!this.props.grouped) {
            return this.props.options;
        }
        return this.memoizedOptions(this.props.options, this.searchQuery, this.props.value, this.props.multiple);
    }
    isOptionSuitable(option, searchQuery) {
        if (option.text == null) {
            return true;
        }
        return option.text
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase());
    }
    render() {
        const _a = this.props, { className, grouped, large, onChange, onClose, onSearchChange, options, size, small, value } = _a, props = __rest(_a, ["className", "grouped", "large", "onChange", "onClose", "onSearchChange", "options", "size", "small", "value"]);
        let realSize = size;
        if (small)
            realSize = 'small';
        if (large)
            realSize = 'large';
        const SelectClasses = classnames('Select', className, {
            'Select--small': realSize === 'small',
            'Select--large': realSize === 'large',
            'Select--grouped': grouped,
        });
        const realValue = value === undefined ? (this.props.multiple ? [] : '') : value;
        return (React.createElement(Dropdown, Object.assign({}, props, { selectOnBlur: false, options: this.options, value: realValue, onChange: this.handleChange, onSearchChange: this.handleSearchChange, onClose: this.handleClose, className: SelectClasses })));
    }
}
Select.defaultProps = {
    selection: true,
    size: 'medium',
};
Select.displayName = 'Select';
//# sourceMappingURL=Select.js.map